<template>
  <div class="tmbz">
    <headerBanner :bannerUrl='domain+data.bgpic'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i2"></i></div><p>{{data.name}}</p>
    </div>
   <!--  <div class="zxxy_person clearfix">
     <img src="../../static/images/zzxy_zx.jpg" alt="">
     <div class="person_detail">
       <p class="name">吴港平</p>
       <P class='zw'>安永中国主席 |  大中华首席合伙人</P>
     </div>
   </div> -->
     <div v-html='data.content' v-if='data.content'>
     </div>
     <div v-else>
      <div class="tmbz_detail">
        <p class="name_big">公开提名</p>
        <p class="name_sm">被提名企业需满足以下四项基本要求：</p>
        <div class="tmbz_list">
          <div class="y_bc"></div>
          <div class="tmbz_item clearfix">
            <div class="circle EY_Bold">1</div><p>非上市公司</p>
          </div>
          <div class="tmbz_item clearfix">
            <div class="circle EY_Bold">2</div><p>最新会计年度员工数量><span class="EY_Regular">100</span>人</p>
          </div>

          <div class="tmbz_item clearfix">
            <div class="circle EY_Bold">3</div><p>销售收入最近会计年度≥人民币<span class="EY_Regular">1</span>亿元（新行业可以相应降低）</p>
          </div>

          <div class="tmbz_item clearfix">
            <div class="circle EY_Bold">4</div><p>销售收入两年平均年增长率≥<span class="EY_Regular">30%</span></p>
            <p>（新行业某些标准可以适当降低）</p>
          </div>
        </div>
        <p class="name_big">评委会推荐</p>
        <p class="name_sm">评委会由安永合伙人和复旦大学管理学院的资深专家和学者共同组成,以确保更多具潜力企业参与评选。</p>

      </div>
      <div class="pxcx_detail">
        <p class="name_big">评选程序</p>
        <div class="title_big">安永及复旦评委会将通过严格的选拔程序，<br>确定最终获奖企业名单。</div>
        <p class="title_sm">评委会成员是由安永合伙人和复旦大学管理学院资深专家和学者组成。<br>当收到提名后，我们将根据被提名企业提供的资料对其进行评估。<br>
  我们会安排与被提名人会面，以获取更多资料，再供评委会评议。</p>
        <p class="title_sm">对于被提名企业，评委会将着重评估如下几个方面：</p>
        <div class="icon_wrap clearfix">
          <div class="icon_item i1">
            
          </div>
          <div class="icon_item i2">
            
          </div>
          <div class="icon_item i3">
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'report',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      url:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_category',
       {
          cid:23
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.cate
        //  if(this.data.fileurl){
        //   this.url = this.domain+this.data.fileurl
        // }else{
        //   this.url = 'javascript:;'
        // }
         
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  i.i2{
    width: 0.34rem;
    height: 0.36rem;
    background-position: -1.41rem -1.45rem;
  }
  .tmbz_detail{
    padding: 0 0.26rem 0 0.43rem;
  }
  .name_big{
    font-family: EY_Regular;
    font-size: 0.28rem;
    color: #000000;
    font-weight: bold;
    margin-bottom: 0.1rem;
  }
  .name_sm{
    font-size: 0.2rem;
    color: #000;
    margin-bottom: 0.25rem;
  }
  .tmbz_list{
    padding-left: 0.3rem;
    position: relative;
    margin-bottom: 0.6rem;
  }
  .tmbz_item{
    font-size: 0.18rem;
    color: #000000;
    font-family: EY_Bold;
    padding: 0rem 0 0.1rem 0;
    border-bottom: 1px dashed #6d6e71;
    position: relative;
  }
  .tmbz_item p{
    float: left;
    margin-top: 0.3rem;
    position: relative;
    top: 0rem;
    padding-left: 0.28rem;

  }
  .tmbz_item .circle{
    float: left;
    width: 0.6rem;
    height: 0.6rem;
    line-height: 0.48rem;
    border-radius: 50%;
    box-sizing: border-box;
    border:0.06rem solid #fcd207;
    font-size: 0.3077rem;
    color: #6d6e71;
    text-align: center;
    position: absolute;
    top: 0.12rem;
    left: -0.38rem;
    background-color:#fff;

  }
  .y_bc{
    height: 2rem;
    width:0.14rem;
    background-color: #fcd207;
    position: absolute;
    left: 0.14rem;
    top: 0.6rem;
  }
  .pxcx_detail{
    padding: 0 0.2rem 0 0.42rem;
  }
  .title_big{
    font-size: 0.24rem;
    color: #6d6e71;
    margin-bottom: 0.32rem;
  }
  .title_sm{
    color: #231f20;
    font-size: 0.2rem;
    margin-bottom: 0.24rem;
  }
  .icon_item{
    float: left;
    width: 1.42rem;
    height: 1.42rem;
    margin-right: 0.5rem;
    background-image: url(../../static/images/pxcx_icons.png);
    background-size: 3.21rem 3.21rem;
  }
  .icon_item.i1{
    background-position: -1.7rem -0.1rem;
  }
  .icon_item.i2{
    background-position: -0.1rem -1.7rem;
  }
  .icon_item.i3{
    background-position: -0.1rem -0.1rem;
  }
  .icon_wrap{
    margin-top: 0.5rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/tmbz.vue